var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 16H376V496H136V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.996 140.196L238.299 175.126C236.291 178.922 232.693 178.57 229.095 176.45L216.283 169.429L225.832 223.081C227.84 232.883 221.397 232.883 218.217 228.644L195.857 202.155L192.227 215.607C191.809 217.374 189.968 219.229 187.207 218.787L158.932 212.496L166.359 241.068C167.949 247.426 169.189 250.058 164.754 251.735L154.676 256.748L203.349 298.586C205.275 300.167 206.248 303.014 205.563 305.592L201.303 320.386C218.061 318.341 233.077 315.266 249.844 313.372C251.325 313.204 253.803 315.789 253.793 317.605L251.572 371.803H259.72L258.438 317.721C258.427 315.906 260.675 313.204 262.156 313.372C278.923 315.266 293.939 318.341 310.698 320.386L306.438 305.592C305.752 303.014 306.725 300.167 308.652 298.586L357.324 256.748L347.246 251.735C342.811 250.058 344.051 247.426 345.641 241.068L353.068 212.496L324.793 218.787C322.032 219.229 320.191 217.374 319.773 215.607L316.143 202.155L293.783 228.644C290.603 232.883 284.16 232.883 286.168 223.081L295.718 169.429L282.905 176.45C279.307 178.57 275.709 178.922 273.701 175.126",
    fill: "#E74C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376 16H496V496H376V16Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H136V496H16V16Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.605f0d98400ad184bfe8e1b633417d9d.svg";
export { ForwardRef as ReactComponent };